import React, { useState } from "react";

export default function Footer(){
    return(
        <div className="footDown">
            <p>
                ©2024 - $42069(k)  • All Rights Reserved
            </p>
        </div>
    )
} 